import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createExternalRouteRef } from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

enum ExternalRoutesIds {
  chat = 'chat',
}

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const ExternalRoutes = {
  chat: chatRouteRef,
};

export const bindHomeModuleChatRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(ExternalRoutes),
    convertLegacyRouteRefs({
      ...extraRoutes,
    }),
  );
};
